import React, { useEffect, useState } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import Input from "../../../components/elements/form/input";
import Teaxtarea from "../../../components/elements/form/textarea";
import SelectBox from "../../../components/elements/form/selectBox";
import { DropdownOptionType, Option } from "../../../_config/types";
import Datepicker from "../../../components/elements/form/datepicker";
import Button from "../../../components/elements/button";
import mapImg from "../../../images/map-left.jpg";
import qrImg from "../../../images/facility-qr.jpg";
import { useFacilitiesApi } from "../../../store/api/hooks/facilitiesApiHook";
import toast from "react-hot-toast";
import { useCommonApi } from "../../../store/api/hooks/commonApiHook";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import Icon from "../../../components/icons";
import FileUpload from "../../../components/elements/form/fileUplaod";
import { on } from "events";
import Label from "../../../components/elements/form/fromLabel";
import { PAGE_SIZE } from "../../../_common/constant";
import { useAssetsApi } from "../../../store/api/hooks/assetsApiHook";
import { AgGridReact } from "ag-grid-react";
import { titleCell } from "../../../components/elements/function";
import { useSpearPartsApi } from "../../../store/api/hooks/spearPartsApiHook";
import { useChecklistApi } from "../../../store/api/hooks/checklistApiHook";
import { URLS } from "../../../_config";
import { getPermissionInfo } from "../../../_common/functions";
import { useUserSelector } from "../../../store/selectors/userSelector";

interface Props {
  _ref: React.RefObject<HTMLDialogElement>;
  facility?: any;
  deletedCheckList?: any;
  onCreate?: () => void;
  onCancel?: () => void;
  subFacility?: any;
  onContinue: (asseta: any[]) => void;
}

const CreateCheckListsModal: React.FC<Props> = ({
  _ref,
  facility,
  deletedCheckList,
  onCreate = () => { },
  onCancel = () => { },
  subFacility,
  onContinue,
}) => {
  const facilityApi: any = useFacilitiesApi();
  const checklistAPI: any = useChecklistApi();
  const [subfacilitytype, setsubfacilitytype] = useState<any>([]);
  const { showLoader, hideLoader } = useAppLoader();
  const [subfacilityimg, setSubfacityImg] = useState<any>(null);
  const {
    control,
    register,
    getValues,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<any>();
  const assetsAPI = useAssetsApi();
  const sparePartsAPI = useSpearPartsApi();
  const [searchParam, setSearchParam] = useState<any>("");
  const [rowData, setRowData] = useState<any>([]);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const loggedinuser: any = useUserSelector();
  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      width: 100,
      headerClass: "bg-[#f0f0f0]",
    },
    {
      headerName: "Checklist No",
      field: "checkListCode",
      headerClass: "bg-[#f0f0f0]",
      width: 250,
    },
    {
      headerName: "Title",
      field: "title",
      flex: 1,
      headerClass: "bg-[#f0f0f0]",
      width: 300,
      cellRenderer: (data: any) => {
        return (
          <p
            className="hover:text-primary font-semibold cursor-pointer"
            title={data.value}
          >
            {data.value}
          </p>
        );
      },
    },
    // {
    //   headerName: "Type",
    //   field: "checkListTypeName",
    //   headerClass: "bg-[#f0f0f0]",
    //   flex: 1,
    //   minWidth: 160,
    //   cellRenderer: titleCell,
    // },

  ];
  const [gridApi, setGridApi] = useState<any>(null);
  const [gridColumnApi, setGridColumnApi] = useState<any>(null);

  const onGridReady = (params: any) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  const onRowClicked = (event: any) => {
    if (!event.event.target.closest('input[type="checkbox"]')) {
      event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
    }
  };
  const getSelectedRows = () => {
    const selectedNodes = gridApi?.getSelectedNodes();
    const selectedData = selectedNodes.map((node: any) => node.data);
    setRowData(null);
    return selectedData;
  };
  const colse = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    resetForm();
    _ref?.current?.close();
    onCancel();
  };

  const getChecklists = () => {
    showLoader();
    let payload: any = {
      isGeneric: true,
      searchParam: searchParam,

    };
    if (deletedCheckList) {
      payload.checkListIDs = deletedCheckList.join(",");
    }

    checklistAPI.getChecklists(
      payload,
      (data: any) => {
        setRowData(data.checklistList ? data.checklistList.filter((clitem: any) => clitem.hasTask) : []);
        hideLoader();
        //setTotalRecords(data.totalRecord);
      },
      (error: any) => {
        hideLoader();
      }
    );
  };

  const openChecklistCreateTab = () => {
    const targetUrl = `${window.location.origin}${URLS.CHECKLISTS}?openCreateChecklist=true`;
    window.open(targetUrl, "_blank", "noopener,noreferrer");
  };

  const onSubmit = (data: any) => {
    //  console.log(data);
    let payload: any = {
      subFacilityTypeID: data.subFacilityTypeID.value,
      subFacilityName: data.subFacilityName,
      area: data.area,
      no: data.noOfRanches,
      facilityID: facility,
    };

    if (subFacility) {
      payload = {
        ...payload,
        subFacilityID: subFacility.subFacilityID,
      };
    }

    showLoader();
    facilityApi.saveSubFacility(
      payload,
      (resp: any) => {
        if (typeof data?.fileupload == "object") {
          const formData = new FormData();
          formData.append("inputFile", data.fileupload);
          formData.append("subFacilityID", resp?.returnID);
          facilityApi.SaveSubFacilityImage(
            formData,
            (resp: any) => {
              toast.success("Sub Facility Added Successfully");
              reset();
              hideLoader();
              _ref?.current?.close();
            },
            (error: any) => {
              hideLoader();
              toast.error(error);
            }
          );
        } else {
          hideLoader();
          toast.success("Sub Facility Added Successfully");
          reset();
          _ref?.current?.close();
          return;
        }
      },
      (error: any) => {
        hideLoader();
        toast.error(error);
      }
    );
  };
  const GetSubFacilityTypeList = () => {
    const payload = {
      pageNo: 1,
      pageSize: 10,
    };
    facilityApi.getSubFacilityTypeList(
      payload,
      (resp: any) => {
        // console.log("Subfacility type",resp)
        let servicetech: any = [];

        resp.subFacilityTypeList.map((servicelist: any) => {
          servicetech.push({
            label: servicelist.name,
            value: servicelist.subFacilityTypeID,
          });

          setsubfacilitytype(servicetech);
        });
      },
      (error: any) => {
        //console.log("error =>", error);
        toast.error(error);
      }
    );
  };

  const resetForm = () => {
    reset({
      subFacilityTypeID: null,
      area: null,
      noOfRanches: null,
      fileupload: "",
    });
  };

  useEffect(() => {
    if (subFacility) {
      console.log("edit sub facility with ---- ", subFacility);
      reset({
        subFacilityTypeID: subfacilitytype.find(
          (item: any) => item.value == subFacility.subFacilityTypeID
        ),
        area: subFacility.area,
        noOfRanches: subFacility.no,
        fileupload: subFacility.fullFilePath,
      });
    } else {
      resetForm();
      setRowData(null);
    }
  }, [subFacility]);

  useEffect(() => {
    GetSubFacilityTypeList();
  }, []);



  /* useEffect(() => {
    if(isOpen && facility){
      getChecklists();
    }
  }, [isOpen, facility]); */
  useEffect(() => {
    if (isOpen) {
      getChecklists();
    }
  }, [isOpen]);



  useEffect(() => {
    if (_ref.current) {
      const modal: any = _ref.current;
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "open"
          ) {
            setRowData([]);
            setSearchParam("");
            if (_ref.current?.hasAttribute("open")) {
              setIsOpen(true);

            } else {
              setIsOpen(false);
            }
          }
        }
      });
      if (modal) observer.observe(modal, { attributes: true });
      return () => observer.disconnect();
    }
  }, [_ref]);

  return (
    <dialog ref={_ref} className="modal">
      <div className="modal-box max-w-[90%] w-[70rem] p-8 overflow-hidden">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col h-[calc(100vh-8rem)]"> {/* Adjust height as needed */}
            <div className="flex items-center justify-between border-b border-[#8D6E63] pb-2 mb-2 flex-shrink-0">
              <p className="text-[1.063rem] text-[#755B51] font-semibold">
                {subFacility ? "Edit" : "Add "} Checklist
              </p>
              <button
                onClick={colse}
                className="bg-primary text-white p-1 rounded-md"
              >
                <Icon name="close" size={1.25} />
              </button>
            </div>

            <div className="flex flex-col flex-shrink-0 mb-8">
              {facility && (
                <div className="mb-4">
                  <Label text="Facility" />
                  <p className={`border border-[#D9D9D9] font-normal mt-3 p-4 rounded text-[16px] w-[30rem] text-[#323233]`}>{facility?.label}</p>
                </div>
              )}
              {subFacility && (
                <div className="mb-4">
                  <Label text="Sub Facility" />
                  <p className={`border border-[#D9D9D9] font-normal mt-3 p-4 rounded text-[16px] w-[30rem] text-[#323233]`}>{subFacility?.label}</p>
                </div>
              )}

              <Input
                label="Filter Name"
                type="text"
                value={searchParam}
                onChange={(e: any) => {
                  setSearchParam(e.target.value);
                }}
                placeholder="Filter Name or Serial No"
              />

              <div className="flex items-center gap-3 mt-2 flex-wrap">
                <Button type="button" className="w-fit" onClick={getChecklists}>
                  Search
                </Button>
                <Button disabled={!getPermissionInfo('/checklists', 'Add', loggedinuser)} type="button" theme="secondary" className="w-fit" onClick={openChecklistCreateTab}>
                  Create New Checklist
                </Button>
              </div>
            </div>

            <div className="flex-grow overflow-auto">
              <AgGridReact
                columnDefs={columnDefs} // Pass columnDefs
                rowData={rowData} // Pass rowData
                pagination={false}
                rowSelection="multiple"
                onGridReady={onGridReady}
                domLayout="autoHeight"
                onRowClicked={onRowClicked}
              />
            </div>

            <div className="flex justify-end gap-2 border-t border-[#8D6E63] pt-2 flex-shrink-0">
              <Button
                onClick={() => {
                  const selectedRows = getSelectedRows();
                  setRowData(null);
                  onContinue(selectedRows);
                }}
              >
                Add Checklist
              </Button>
            </div>
          </div>
        </form>
      </div>
      <form method="dialog" className="modal-backdrop" onClick={colse}></form>
    </dialog>
  );
};

export default CreateCheckListsModal;
